export default __webpack_public_path__ + "static/media/dds5168_4p-6.76b56e6f.png";